import { httpsCallable } from "firebase/functions";
import { functions } from ".";
import { isStringNotEmpty } from "../utils/objectUtils";

export const supportChatAI = async (conversationId, messageContent) => {
    if (isStringNotEmpty(conversationId) && isStringNotEmpty(messageContent)) {
        const func = httpsCallable(functions, "supportchatai", { timeout: 120000 });
        const res = await func({ conversationId, messageContent });
        return res.data;
    }

    return null;
};

export const autoAssignTicket = async (ticketId) => {
    if (isStringNotEmpty(ticketId)) {
        const func = httpsCallable(functions, "autoassignticket", { timeout: 30000 });
        const res = await func({ ticketId });
        return res.data;
    }

    return null;
};

export const createGuestSupportChat = async (name, email) => {
    if (isStringNotEmpty(name)) {
        const func = httpsCallable(functions, "createguestsupportchat", { timeout: 60000 });
        const res = await func({ name, email });
        return res.data;
    }

    return null;
};
